var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5385 6.5H14.4615C10.0723 6.5 6.5 10.0723 6.5 14.4615V25.5385C6.5 29.9277 10.0723 33.5 14.4615 33.5H25.5385C29.9277 33.5 33.5 29.9277 33.5 25.5385V14.4615C33.5 10.0723 29.9277 6.5 25.5385 6.5ZM31.4231 25.5385C31.4231 28.7785 28.7785 31.4231 25.5385 31.4231H14.4615C11.2215 31.4231 8.57692 28.7785 8.57692 25.5385V14.4615C8.57692 11.2215 11.2215 8.57692 14.4615 8.57692H25.5385C28.7785 8.57692 31.4231 11.2215 31.4231 14.4615V25.5385Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5742 22.7686L26.3142 24.0286C25.8296 24.5132 25.0819 24.5409 24.5557 24.1117L19.3219 19.7502C18.1034 18.7394 16.3865 18.6979 15.1265 19.6394L11.0696 22.6855C10.6126 23.0317 10.5157 23.6825 10.8619 24.1394C11.208 24.5963 11.8588 24.6932 12.3157 24.3471L16.3726 21.3009C16.8573 20.9409 17.5219 20.9548 17.9926 21.3425L23.2265 25.704C23.8634 26.2302 24.625 26.4932 25.3865 26.4932C26.2588 26.4932 27.1173 26.1609 27.7819 25.4963L29.0419 24.2363C29.4434 23.8348 29.4434 23.1702 29.0419 22.7686C28.6403 22.3671 27.9757 22.3671 27.5742 22.7686Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8468 18.2687C26.5638 18.2687 27.9622 16.8703 27.9622 15.1533C27.9622 13.4364 26.5638 12.038 24.8468 12.038C23.1299 12.038 21.7314 13.4364 21.7314 15.1533C21.7314 16.8703 23.1299 18.2687 24.8468 18.2687ZM24.8468 14.1149C25.4145 14.1149 25.8853 14.5857 25.8853 15.1533C25.8853 15.721 25.4145 16.1918 24.8468 16.1918C24.2791 16.1918 23.8084 15.721 23.8084 15.1533C23.8084 14.5857 24.2791 14.1149 24.8468 14.1149Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBase);
export default __webpack_public_path__ + "static/media/base.be0b302f.svg";
export { ForwardRef as ReactComponent };